import { addToDate, toCondensedDateTime } from "../../utils/date-utils";

export class CachedStoreObject<T> {

    public expiresAt : string = '';
    public data : T = {} as T;

    /**
     * 
     * @param data The data to cache
     * @param duration The number of minutes to cache the data for
     */
    constructor(data : T, duration: number) {
        this.data = data;

        const newExpTime = addToDate(new Date(), duration, 'minutes');
        this.expiresAt = toCondensedDateTime(newExpTime);
    }

}
